import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios'
import { endpoints } from "../../../../endpoints";

export const allPosts = createAsyncThunk("/posts/allPosts" , async (payload , Thunk) =>{
    try {
        const response = await axios.post(endpoints.posts.getList , payload)
        return response.data;
    }
    catch(err){
        return Thunk.rejectWithValue(err)
    }
})

export const deletePost = createAsyncThunk("/posts/delete" , async (payload , Thunk) =>{
    try {
        const response = await axios.post(endpoints.posts.deletePost , payload)
        return response.data;
    }
    catch(err){
        return Thunk.rejectWithValue(err)
    }
})

